import {
  V2ListOpenRouterKeysForAccountApiArg,
  useV2ListOpenRouterKeysForAccountQuery,
} from "@generated";
import type { OpenRouterKey } from "../types";

export interface HookArgs {
  page?: V2ListOpenRouterKeysForAccountApiArg["page"];
}

const useListOpenRouterKeys = ({ page }: HookArgs) => {
  const { data, error, isLoading, refetch } =
    useV2ListOpenRouterKeysForAccountQuery({ page });

  let openRouterKeys: OpenRouterKey[] = [];
  let customError: string | null = null;
  let pageMeta = {
    recordCount: 0,
    pageCount: 0,
  };

  if (data?.data) {
    try {
      openRouterKeys = data.data.map((key) => {
        if (!key.id) {
          throw new Error("Missing open router key id");
        }

        const attrs = key.attributes as Record<string, any> | undefined;
        const keyType = attrs?.["key-type"] || "";

        let identifier = "";
        if (keyType === "azure") {
          identifier = attrs?.["model-slug"] || "";
        } else if (keyType === "aws_bedrock") {
          identifier = attrs?.region || "";
        } else if (keyType === "google_vertex") {
          identifier = attrs?.["project-id"] || "";
        }

        return {
          id: String(key.id),
          name: attrs?.name || "",
          keyType,
          identifier,
          default: attrs?.default === true,
        };
      });

      if (!data.meta) {
        throw new Error("Missing data.meta");
      }

      if (!data.meta["record-count"]) {
        throw new Error('Missing data.meta["record-count"]');
      }

      if (!data.meta["page-count"]) {
        throw new Error('Missing data.meta["page-count"]');
      }
      pageMeta = {
        recordCount: data.meta["record-count"],
        pageCount: data.meta["page-count"],
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    openRouterKeys,
    error: error || customError,
    isLoading,
    pageMeta,
    refetch,
  };
};

export default useListOpenRouterKeys;
